// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1mPsx","requiredAsterisk":"Info_requiredAsterisk__1cSoX"};